export const proratedPricePopUpStyles = {
	dialog: {
		'& .MuiDialog-paper': {
			backgroundColor: 'transparent',
			scale: { xs: '1', sm: '1.3' },
			overflow: 'visible',
		},
		'& > .MuiBackdrop-root': {
			backdropFilter: 'blur(4px)',
			backgroundColor: 'rgb(0, 0, 0, 0.8)',
		},
	},
	popUp: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',

		textAlign: 'center',
	},
	paymentResultPopUp: {
		'& .lottie-cont': {
			display: 'flex',
			alignItems: 'center',
		},
	},
};
